import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ru: {
    translation: {
      "app_title": "Система инвентаризации",
      "login": "Вход",
      "email": "Email",
      "password": "Пароль",
      "set_password": "Установить пароль",
      "logout": "Выход",
      "dashboard": "Панель управления",
      "map": "Карта",
      "devices": "Устройства",
      "locations": "Локации",
      "device_types": "Типы устройств",
      "characteristics": "Характеристики",
      "data_types": "Типы данных",
      "connections": "Подключения",
      "users": "Пользователи",
      "roles": "Роли",
      "settings": "Настройки",
      "audit_log": "История изменений"
    }
  },
  uk: {
    translation: {
      "app_title": "Система інвентаризації",
      "login": "Вхід",
      "email": "Email",
      "password": "Пароль",
      "set_password": "Встановити пароль",
      "logout": "Вихід",
      "dashboard": "Панель керування",
      "map": "Карта",
      "devices": "Пристрої",
      "locations": "Локації",
      "device_types": "Типи пристроїв",
      "characteristics": "Характеристики",
      "data_types": "Типи даних",
      "connections": "Підключення",
      "users": "Користувачі",
      "roles": "Ролі",
      "settings": "Налаштування",
      "audit_log": "Історія змін"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ru',
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
